import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Paper, Divider } from "@mui/material";
// import { convertEpochToDateDMY } from "../../../../utils";
import FormattedDate from "../../../../components/TimeStamp";

const PaymentReceipt = ({ scrutinyTable, scrutinyDetails, wordslist, logoData }) => {
  // console.log(scrutinyDetails, scrutinyTable, wordslist, "wwwwww");

  // const date = convertEpochToDateDMY(scrutinyTable?.auditDetails.createdTime);
  const authorityName = scrutinyDetails?.department === "DA" ? "Development Authority" : "Avas Vikas Parishad";
  const receiptLog = scrutinyDetails?.department === "DA" ? true : false;
  const locationName = scrutinyDetails?.applicationType === "FORM_LANDUSE" ? scrutinyDetails?.location1 : scrutinyDetails?.locationDistrict;

  return (
    <React.Fragment>
      {scrutinyTable && (
        <div>
          <Box className="paymentReceipt">
            <Paper elevation={3} className="receipt-paper">
              <Box className="header" sx={{ textAlign: "center", mb: 2 }}>
                <Typography variant="h5" fontWeight="bold">
                  <div className="row">
                    <p style={{ width: "22%", height: "0em" }}>
                      <img src={logoData} alt="logo" style={{ width: receiptLog ? "5em" : "8em", height: receiptLog ? "3em" : "4em" }} />
                    </p>
                    <div style={{ width: "85%", margin: "auto" }}>
                      <p>
                        {locationName} {authorityName}
                      </p>
                      <Box className="receipt-title">Payment Receipt</Box>
                    </div>
                  </div>
                </Typography>
              </Box>

              <Divider sx={{ borderColor: "black" }} />

              <Box className="section" sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  {scrutinyDetails?.applicationNo && (
                    <Grid item xs={6}>
                      <strong>File Number:</strong> {scrutinyDetails?.applicationNo}
                    </Grid>
                  )}
                  {scrutinyTable?.txnId && (
                    <Grid item xs={6}>
                      <strong>Receipt No:</strong> {scrutinyTable?.txnId}
                    </Grid>
                  )}

                  {(scrutinyDetails?.descriptionOfLand?.khasraDetails?.[0]?.plotNo || scrutinyDetails?.plotNo) && (
                    <Grid item xs={6}>
                      <strong>Plot No:</strong> {scrutinyDetails?.descriptionOfLand?.khasraDetails?.[0]?.plotNo || scrutinyDetails?.plotNo}
                    </Grid>
                  )}
                  {scrutinyDetails?.natureOfConstruction && (
                    <Grid item xs={6}>
                      <strong>Application type:</strong> {scrutinyDetails?.natureOfConstruction}
                    </Grid>
                  )}

                  {scrutinyTable?.auditDetails?.createdTime && (
                    <Grid item xs={6}>
                      <strong>Receipt Date:</strong>
                      <FormattedDate timestamp={scrutinyTable?.auditDetails.createdTime} />
                    </Grid>
                  )}
                  {locationName && (
                    <Grid item xs={6}>
                      <strong>City Name:</strong> {locationName}
                    </Grid>
                  )}
                  {scrutinyDetails?.descriptionOfLand?.subLandUseAsPerLayout && (
                    <Grid item xs={6}>
                      <strong>Plot sub use:</strong> {scrutinyDetails?.descriptionOfLand?.subLandUseAsPerLayout}
                    </Grid>
                  )}

                  {(scrutinyDetails?.descriptionOfLand?.schemeName || scrutinyDetails?.schemeName) && (
                    <Grid item xs={6}>
                      <strong>Scheme Name:</strong> {scrutinyDetails?.descriptionOfLand?.schemeName || scrutinyDetails?.schemeName}
                    </Grid>
                  )}

                  {scrutinyDetails?.landInfo?.owners?.[0]?.name && (
                    <Grid item xs={6}>
                      <strong>Owner Name:</strong>Sh./Smt. {scrutinyDetails?.landInfo?.owners?.[0]?.name}
                    </Grid>
                  )}

                  {scrutinyDetails?.descriptionOfLand?.landAddress && (
                    <Grid item xs={12}>
                      <strong>Property address:</strong> {scrutinyDetails?.descriptionOfLand?.landAddress} , Uttar Pradesh
                    </Grid>
                  )}

                  {scrutinyDetails?.landInfo?.owners?.[0]?.correspondenceAddress?.address && (
                    <Grid item xs={12}>
                      <strong>Owner Communication Address:</strong> {scrutinyDetails?.landInfo?.owners?.[0]?.correspondenceAddress?.address} , Uttar
                      Pradesh
                      {scrutinyDetails?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno
                        ? `, ${scrutinyDetails?.landInfo?.owners?.[0]?.correspondenceAddress?.pinno}`
                        : ""}
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Paper>
          </Box>
          <Box className="paymentReceipt">
            <Paper elevation={3} className="receipt-paper">
              <Box className="section" sx={{ mt: 4 }}>
                <Typography variant="h6" className="section-heading">
                  Payment Details
                </Typography>
                <Box className="payment-info">
                  <p>
                    <strong>Total (In INR):</strong> ₹{scrutinyTable?.txnAmount}
                  </p>
                  <p>
                    <strong>Amount (In Words):</strong> {wordslist}
                  </p>
                  {/* <p>
                    <strong>Transaction Type:</strong> Net Banking / Credit Card / Debit Card / UPI
                  </p> */}
                  <p>
                    <strong>Payment Mode:</strong>
                    {scrutinyTable?.additionalDetails?.paymentMode || "N/A"}
                  </p>
                  <p>
                    <strong>Transaction Id:</strong> {scrutinyTable?.txnId}
                  </p>
                  <p>
                    <strong>Bill Id:</strong> {scrutinyTable?.additionalDetails?.billIdFromDoubleVerification || "N/A"}
                  </p>
                  <p>
                    <strong>UTR:</strong> {scrutinyTable?.additionalDetails?.utrNo || "N/A"}
                  </p>
                </Box>
              </Box>
            </Paper>
          </Box>
        </div>
      )}
    </React.Fragment>
  );
};

export default PaymentReceipt;
